
























import { Component, Prop, Vue } from "vue-property-decorator";
import { pusher } from "@/services/PusherClient";
import OrderBankDarahStore from "@/store/modules/OrderBankDarahStore";

interface OrderMasukPayload {
  nomor: string | null;
  jenis_label: string;
  unit_pemohon_nama: string | null;
}

@Component
export default class OrderBankDarahAlarmListener extends Vue {
  @Prop({ type: String, required: true }) readonly unitId!: string;

  show = false;
  order: OrderMasukPayload | null = null;
  jumlahLain = 0;

  private channel: any = null;
  private audioCtx: AudioContext | null = null;

  mounted() {
    this.channel = pusher.subscribe(`unit.${this.unitId}`);
    this.channel.bind("order-bank-darah.masuk", this.onOrder);
    document.addEventListener("click", this.primeAudio, { once: true });
  }

  beforeDestroy() {
    if (this.channel) {
      this.channel.unbind("order-bank-darah.masuk", this.onOrder);
    }
    document.removeEventListener("click", this.primeAudio);
  }

  onOrder(data: OrderMasukPayload) {
    if (this.show) {
      this.jumlahLain++;
    } else {
      this.order = data;
      this.jumlahLain = 0;
      this.show = true;
    }
    this.playBeep();
    OrderBankDarahStore.fetchCount();
  }

  close() {
    this.show = false;
  }

  goToPage() {
    this.close();
    if (this.$route.name !== "daftar-pasien") {
      this.$router.push({ name: "daftar-pasien" });
    } else {
      this.$root.$emit("order-bank-darah:muat-ulang");
    }
  }

  private primeAudio() {
    this.ensureAudio();
  }

  private ensureAudio() {
    if (!this.audioCtx) {
      const AC = window.AudioContext || (window as any).webkitAudioContext || null;
      if (AC) this.audioCtx = new AC();
    }
    if (this.audioCtx && this.audioCtx.state === "suspended") {
      this.audioCtx.resume().catch(() => undefined);
    }
  }

  private playBeep() {
    this.ensureAudio();
    if (!this.audioCtx || this.audioCtx.state !== "running") return;
    const ctx = this.audioCtx;
    for (let i = 0; i < 2; i++) {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = "sine";
      osc.frequency.value = 660;
      gain.gain.value = 0.15;
      osc.connect(gain);
      gain.connect(ctx.destination);
      const t = ctx.currentTime + i * 0.3;
      osc.start(t);
      osc.stop(t + 0.18);
    }
  }
}
